var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetRestaurantByIdQuery } from '@/services/restaurantsApi';
import './productsTab.module.css';
import AddIcon from '@assets/svg/addIcon.svg';
import { useState } from 'react';
import { Modal, Input, Form, Button, message, Upload } from 'antd';
import { UploadOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import { useCreateProductMutation, useDeleteProductMutation, useUpdateProductMutation, } from '@/services/productApi';
var ProductTab = function (_a) {
    var _b;
    var restId = _a.restId;
    var _c = useGetRestaurantByIdQuery(Number(restId)), restaurantsData = _c.data, isRestaurantsLoading = _c.isLoading, refetch = _c.refetch;
    var _d = useState(false), isModalVisible = _d[0], setIsModalVisible = _d[1];
    var form = Form.useForm()[0];
    var _e = useCreateProductMutation(), createProduct = _e[0], isCreating = _e[1].isLoading;
    var _f = useUpdateProductMutation(), updateProduct = _f[0], isUpdating = _f[1].isLoading;
    var deleteProduct = useDeleteProductMutation()[0];
    var _g = useState([]), fileList = _g[0], setFileList = _g[1];
    var _h = useState(null), viewImageUrl = _h[0], setViewImageUrl = _h[1];
    // Состояние для редактируемого продукта (null — создаём новый)
    var _j = useState(null), editingProduct = _j[0], setEditingProduct = _j[1];
    // Открываем модалку для создания продукта
    var handleOpenModal = function () {
        setEditingProduct(null);
        form.resetFields();
        setFileList([]);
        setIsModalVisible(true);
    };
    // Открываем модалку для редактирования продукта
    var handleEditProduct = function (product) {
        setEditingProduct(product);
        form.setFieldsValue({
            name: product.name,
            description: product.description,
            cost: product.cost,
        });
        setFileList([]);
        setIsModalVisible(true);
    };
    var handleCloseModal = function () {
        setIsModalVisible(false);
        form.resetFields();
        setFileList([]);
        setEditingProduct(null);
    };
    var onUploadChange = function (_a) {
        var fileList = _a.fileList;
        setFileList(fileList);
    };
    var handleSubmit = function () {
        return __awaiter(void 0, void 0, void 0, function () {
            var values, formData, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 6, , 7]);
                        return [4 /*yield*/, form.validateFields()];
                    case 1:
                        values = _a.sent();
                        formData = new FormData();
                        formData.append('name', values.name);
                        formData.append('description', values.description || '');
                        formData.append('cost', values.cost.toString());
                        formData.append('restaurantId', restId.toString());
                        if (fileList.length > 0) {
                            formData.append('file', fileList[0].originFileObj);
                        }
                        if (!editingProduct)
                            return [3 /*break*/, 3];
                        // Обновление продукта
                        return [4 /*yield*/, updateProduct({ id: editingProduct.id, body: formData }).unwrap()];
                    case 2:
                        // Обновление продукта
                        _a.sent();
                        message.success('Продукт успешно обновлён');
                        return [3 /*break*/, 5];
                    case 3:
                        // Создание нового продукта
                        return [4 /*yield*/, createProduct(formData).unwrap()];
                    case 4:
                        // Создание нового продукта
                        _a.sent();
                        message.success('Продукт успешно добавлен');
                        _a.label = 5;
                    case 5:
                        handleCloseModal();
                        refetch();
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        console.error('Ошибка при сохранении продукта:', error_1);
                        message.error('Ошибка при сохранении продукта');
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    var handleDeleteProduct = function (id) {
        Modal.confirm({
            title: 'Удаление продукта',
            content: 'Вы уверены, что хотите удалить этот продукт?',
            okText: 'Удалить',
            okType: 'danger',
            cancelText: 'Отмена',
            onOk: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, deleteProduct(id).unwrap()];
                            case 1:
                                _a.sent();
                                message.success('Продукт удалён');
                                refetch();
                                return [3 /*break*/, 3];
                            case 2:
                                err_1 = _a.sent();
                                message.error('Ошибка при удалении');
                                return [3 /*break*/, 3];
                            case 3: return [2 /*return*/];
                        }
                    });
                });
            },
        });
    };
    if (isRestaurantsLoading) {
        return _jsx("div", { children: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u043E\u0432..." });
    }
    var products = (_b = restaurantsData === null || restaurantsData === void 0 ? void 0 : restaurantsData.product) !== null && _b !== void 0 ? _b : [];
    return (_jsxs("div", __assign({ className: "productsTab" }, { children: [_jsxs("div", __assign({ className: "titleBlock", style: { display: 'flex', alignItems: 'center', gap: 12 } }, { children: [_jsx(AddIcon, { style: { cursor: 'pointer' }, onClick: handleOpenModal }), _jsx("p", { children: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u044B \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0436\u043D\u043E \u043A\u0443\u043F\u0438\u0442\u044C \u0437\u0430 Egocoin" })] })), _jsxs("div", __assign({ className: "productsList", style: { display: 'flex', flexWrap: 'wrap', gap: 16 } }, { children: [products.length === 0 && _jsx("p", { children: "\u041F\u0440\u043E\u0434\u0443\u043A\u0442\u044B \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442" }), products.map(function (product) {
                        return (_jsxs("div", __assign({ style: {
                                width: 160,
                                border: '1px solid #eee',
                                borderRadius: 8,
                                padding: 8,
                                boxShadow: '0 2px 6px rgb(0 0 0 / 0.1)',
                                position: 'relative',
                            } }, { children: [_jsx(CloseOutlined, { onClick: function () { return handleDeleteProduct(product.id); }, style: {
                                        position: 'absolute',
                                        top: 6,
                                        right: 6,
                                        color: '#fff',
                                        fontSize: 14,
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        padding: 4,
                                        borderRadius: '50%',
                                    } }), _jsx(EditOutlined, { onClick: function () { return handleEditProduct(product); }, style: {
                                        position: 'absolute',
                                        top: 6,
                                        left: 6,
                                        color: '#fff',
                                        fontSize: 14,
                                        cursor: 'pointer',
                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                        padding: 4,
                                        borderRadius: '50%',
                                    } }), _jsxs("div", __assign({ onClick: function () { return product.imgUrl && setViewImageUrl(product.imgUrl); }, style: { cursor: 'pointer' } }, { children: [product.imgUrl ? (_jsx("img", { src: product.imgUrl, alt: product.name, style: { width: '100%', height: 120, objectFit: 'cover', borderRadius: 8 } })) : (_jsx("div", __assign({ style: {
                                                width: '100%',
                                                height: 120,
                                                backgroundColor: '#f0f0f0',
                                                borderRadius: 8,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#999',
                                            } }, { children: "\u041D\u0435\u0442 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F" }))), _jsx("p", __assign({ style: { marginTop: 8, fontWeight: 'bold', fontSize: 14, textAlign: 'center' } }, { children: product.name })), (product === null || product === void 0 ? void 0 : product.description) && (_jsx("p", __assign({ style: { marginTop: 4, fontSize: 12, color: '#555', textAlign: 'center' } }, { children: product.description }))), _jsxs("p", __assign({ style: { marginTop: 4, fontSize: 12, color: '#666', textAlign: 'center' } }, { children: ["\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C: ", product.cost, " egocoin"] }))] }))] }), product.id));
                    })] })), _jsx(Modal, __assign({ visible: !!viewImageUrl, footer: null, onCancel: function () { return setViewImageUrl(null); }, bodyStyle: { padding: 0, textAlign: 'center' }, width: 400 }, { children: _jsx("img", { src: viewImageUrl || '', alt: "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430", style: { maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' } }) })), _jsx(Modal, __assign({ title: editingProduct ? 'Редактировать продукт' : 'Добавить продукт', open: isModalVisible, onCancel: handleCloseModal, onOk: handleSubmit, okText: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C", cancelText: "\u041E\u0442\u043C\u0435\u043D\u0430", confirmLoading: isCreating || isUpdating, okButtonProps: {
                    style: {
                        backgroundColor: 'rgb(230, 33, 211)',
                        borderColor: 'rgb(230, 33, 211)',
                        color: '#fff',
                    },
                } }, { children: _jsxs(Form, __assign({ layout: "vertical", form: form }, { children: [_jsx(Form.Item, __assign({ name: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430", rules: [{ required: true, message: 'Введите название' }] }, { children: _jsx(Input, { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430" }) })), _jsx(Form.Item, __assign({ name: "description", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)" }, { children: _jsx(Input, { placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435" }) })), _jsx(Form.Item, __assign({ name: "cost", label: "\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C (\u0432 egocoin)", rules: [{ required: true, message: 'Введите стоимость' }] }, { children: _jsx(Input, { type: "number", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C" }) })), _jsx(Form.Item, __assign({ label: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043F\u0440\u043E\u0434\u0443\u043A\u0442\u0430" }, { children: _jsx(Upload, __assign({ beforeUpload: function () { return false; }, onChange: onUploadChange, fileList: fileList, maxCount: 1, accept: "image/*", listType: "picture" }, { children: _jsx(Button, __assign({ icon: _jsx(UploadOutlined, {}) }, { children: "\u0412\u044B\u0431\u0440\u0430\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435" })) })) }))] })) }))] })));
};
export default ProductTab;
